import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth, { AccessToken } from '@okta/okta-auth-js';
import { from, Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { AuthService } from './services/auth';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  authService = inject(AuthService);

  private oktaAuth = inject<OktaAuth>(OKTA_AUTH);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const accessToken$ = from(this.oktaAuth.tokenManager.get('accessToken'));

    return accessToken$.pipe(
      switchMap((accessToken: AccessToken) => {
        const headers: Record<string, string> = {
          'Cache-control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: '-1',
        };

        if (accessToken?.accessToken) {
          headers.Authorization = `Bearer ${accessToken.accessToken}`;
        }

        const resetToken = this.authService.currentResetToken;
        if (!accessToken?.accessToken && resetToken) {
          headers['Salesforce-Authorization'] = `Bearer ${resetToken}`;
          headers['Content-Type'] = 'application/json';
          this.authService.resetTokenSubject.next(null);
        }

        const clonedRequest = req.clone({ setHeaders: headers });
        return next.handle(clonedRequest);
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && !req.url.includes('/auth/')) {
          this.authService.signOut();
        }
        return throwError(() => error);
      }),
    );
  }
}
